let router = [{
  value: 'amall_0',
  lable: '首页',
  icon: 'home',
  isWorkOrder: false,
  children: [{
    value: '/',
    lable: '首页'
  }]
}, {
  value: 'amall_1',
  lable: '商品管理',
  icon: 'control',
  isWorkOrder: false,
  children: [{
    value: '/upload_product',
    lable: '商品发布',
  }, {
    value: '/control_product',
    lable: '商品管理',
  }, {
    value: '/control_mate',
    lable: '设备材料库',
  },
  {
    value: '/agenManagement',
    lable: '代理人管理'
  }]
}, {
  value: 'amall_2',
  lable: '交易管理',
  isWorkOrder: true,
  icon: 'transaction',
  children: [{
    isWorkOrder: false,
    value: '/control_order',
    lable: '我的订单',
  }, {
    isWorkOrder: true,
    value: '/control_wallet',
    lable: '我的钱包',
  }, {
    isWorkOrder: true,
    value: '/control_project',
    lable: '工程管理',
  },
  //{
  //   isWorkOrder: true,
  //   value: '/Aicontrol_project',
  //   lable: '工程管理', //艾工单里面的
  // },
  {
    isWorkOrder: true,
    value: '/projectTemplate',
    lable: '施工记录规范',
  },
  {
    isWorkOrder: true,
    value: '/constructionStandard',
    lable: '施工规范',
  }
  ]
}, {
  value: 'amall_3',
  lable: '店铺设置',
  icon: 'shop',
  isWorkOrder: true,
  children: [{
    isWorkOrder: true,
    value: '/control_shop',
    lable: '店铺信息'
  }, {
    isWorkOrder: false,
    value: '/control_service',
    lable: '客服设置'
  }, {
    isWorkOrder: true,
    value: '/control_member',
    lable: '成员管理'
  },
  {
    isWorkOrder: false,
    value: '/siteCLock',
    lable: '工地打卡'
  }
  ]
}, {
  value: 'amall_4',
  lable: '需求管理',
  icon: 'container',
  isWorkOrder: true,
  children: [{
    isWorkOrder: true,
    value: '/control_badding',
    lable: '招标管理'
  }, {
    isWorkOrder: true,
    value: '/control_bad',
    lable: '投标管理'
  }]
},
{
  value: 'amall_5',
  lable: '活动管理',
  icon: 'gift',
  isWorkOrder: false,
  children: [{
    isWorkOrder: true,
    value: '/priceManage',
    lable: '出价管理'
  }, {
    isWorkOrder: true,
    value: '/bidDetails',
    lable: '出价明细'
  }, {
    isWorkOrder: true,
    value: '/seckill',
    lable: '秒杀'
  }, {
    isWorkOrder: true,
    value: '/groupPurchase',
    lable: '团购'
  },]
}
]
export default router



// WEBPACK FOOTER //
// ./src/router/components.js